import React from 'react';

// Short time for a notification's createdAt ("2026-07-22 18:57:01"): HH:MM if today, else DD/MM.
function fmtTime(createdAt) {
    if (!createdAt) return '';
    const d = new Date(String(createdAt).replace(' ', 'T'));
    if (isNaN(d.getTime())) return '';
    const now = new Date();
    if (d.toDateString() === now.toDateString()) {
        return d.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' });
    }
    return d.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit' });
}

// Colour group per notification type — a small dot gives quick scannability without clutter.
function toneOf(type) {
    switch (type) {
        case 'booking_manual': return 'manual';
        case 'booking_reminder': return 'reminder';
        case 'booking_cancel':
        case 'booking_noshow': return 'alert';
        case 'booking_new':
        default: return 'new';
    }
}

// A single notification row. Prop-driven; unread rows get a subtle highlight + filled dot.
const Notifhp = ({ type, title = '', body = '', createdAt, isRead = 1 }) => (
    <div className={`hp-notif${Number(isRead) ? '' : ' hp-notif--unread'}`}>
        <span className={`hp-notif-dot hp-notif-dot--${toneOf(type)}`} aria-hidden="true" />
        <div className="hp-notif-main">
            {title ? <span className="hp-notif-title">{title}</span> : null}
            <span className="hp-notif-text">{body}</span>
        </div>
        <span className="hp-notif-date" dir="ltr">{fmtTime(createdAt)}</span>
    </div>
);

export default Notifhp;
